import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t;

import { useEffect } from 'react';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import * as ProductLines from 'self-service-api/constants/ProductLines';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { useTrackRetail } from '../../hooks/useTrackRetail';
import Screens from '../../constants/routing/Screens';
import { useSelector } from 'react-redux';
import { ENTERPRISE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { useAppSelector } from '../../reducers';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { suiteProductConfigurationsSelector } from '../../selectors/ProductConfigsSelectors';
import { hasPaidHubInProductInventorySelector, hasProductVersionInProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { CREATE_A_BUNDLE } from '../../constants/tracking/Locations';
import PhoneSupport from '../common/PhoneSupport';
import AddonsAndServicesPickerList from '../plan-builder/AddonsAndServicesPickerList';
import HubPlanPickerList from '../plan-builder/HubPlanPickerList';
import PlanBuilder from '../plan-builder/PlanBuilder';
import SummaryColumn from '../plan-builder/SummaryColumn';
import styled from 'styled-components';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import MobileWrapperNoTabs from './containers/MobileWrapperNoTabs';
import { NavItemEnum } from '../../constants/routing/NavItems';
import { useQueryParamsEffect, useQueryParamTerm } from '../../utils/urls/queryParamUtils';
const BottomSectionWrapper = styled.div.withConfig({
  displayName: "MobileBundlePage__BottomSectionWrapper",
  componentId: "sxr4rs-0"
})(["width:inherit;margin-top:34px;margin-left:10px;", ";"], breakpoint.cs(_t || (_t = _`
margin: 0 auto;
`)));

const MobileBundlePage = () => {
  useDocumentTitle('bundle');
  useTrackRetail();
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: Screens.BUNDLE
    });
  }, []);
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector); // const hasPricingAndPurchasingFailed = useSelector(
  //   hasPricingAndPurchasingFailedSelector
  // );

  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  const initialProductConfigurations = useAppSelector(state => {
    if (!hasPricingAndPurchasingSucceeded || hasPaidHubInProductInventorySelector(state, {
      productLevels: [PROFESSIONAL, ENTERPRISE]
    })) {
      return [];
    }

    return suiteProductConfigurationsSelector(state, {
      productLevel: STARTER
    }).filter(({
      skuId
    }) => !hasProductVersionInProductInventorySelector(state, {
      skuId
    }));
  });
  return /*#__PURE__*/_jsx(MobileWrapperNoTabs, {
    navMarkerName: 'BUNDLE_PAGE',
    navItem: NavItemEnum.BUNDLE,
    children: /*#__PURE__*/_jsx(PlanBuilder, {
      initialProductConfigurations: initialProductConfigurations,
      allowUpgradesToCrmSuite: true,
      trackingSource: CREATE_A_BUNDLE,
      screen: Screens.BUNDLE,
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HubPlanPickerList, {
          productLines: ProductLines.AllProductLines
        }), /*#__PURE__*/_jsx(AddonsAndServicesPickerList, {
          defaultOpen: true,
          showServicesSection: true,
          screen: Screens.BUNDLE
        }), /*#__PURE__*/_jsxs(BottomSectionWrapper, {
          children: [/*#__PURE__*/_jsx(SummaryColumn, {
            shareLinkAnchor: "",
            hubsSignupProductOverride: "bundle"
          }), /*#__PURE__*/_jsx(PhoneSupport, {
            className: "m-top-5",
            phoneSourceId: "bundle",
            border: false,
            screen: Screens.BUNDLE
          })]
        })]
      })
    })
  });
};

export default MobileBundlePage;